export interface CreatedPurchaseOrder {
  id: string;
  purchaseOrderNumber: number;
  supplierKey: string;
  supplierName: string;
  currencyCode: string;
  noOfLines: number;
  productKey: string;
  productDescription: string;
  productTypeDescription: string;
  quantity: number;
  unitOfMeasure: string;
  price: number;
  value: number;
  deliveryDate: Date;
}
